import { ChatSessionListItem, CostBreakdown } from './types';

export const formatUsd = (value: number): string => value.toFixed(2);

export const sumSessionSpend = (sessions: ChatSessionListItem[]): number => sessions
  .reduce((sum, session) => sum + (session.totalCostUsd || 0), 0);

// The live breakdown wins over the list row, which lags behind the exchange
// that has just been paid for.
export const currentConversationSpend = (
  costBreakdown: CostBreakdown | null,
  sessionId: string | null,
  sessions: ChatSessionListItem[],
): number | null => {
  if (costBreakdown) return costBreakdown.totalCostUsd;
  if (!sessionId) return null;

  const matchedSession = sessions.find((session) => session.id === sessionId);
  return matchedSession ? matchedSession.totalCostUsd : null;
};
